<nav class="main-navigation" data-cy="main-navigation" aria-label="Main navigation">
  <div class="main-navigation__items">
    @for (item of navigationItems; track item.id) {
      @if (item.isVisible) {
        <button
          type="button"
          class="main-navigation__item"
          [class.main-navigation__item--active]="item.isActive"
          (click)="onNavigationItemClick(item)"
          [attr.data-cy]="item.dataCy"
          qimaTooltip
          [qimaTooltipPosition]="qimaTooltipPosition"
          [qimaTooltipText]="item.labelKey | translate"
          [qimaTooltipStrategy]="qimaTooltipStrategy"
          [qimaTooltipStyle]="qimaTooltipStyle"
        >
          <ng-container [ngTemplateOutlet]="navigationItemContent" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
        </button>
      }
    }
  </div>
</nav>

<ng-template #navigationItemContent let-item>
  <span class="main-navigation__item-icon">
    <qima-icon [qimaIconName]="item.icon" [qimaIconSize]="20"></qima-icon>
  </span>
  @if (item.badgeCount) {
    <span class="main-navigation__badge">{{ item.badgeCount }}</span>
  }
</ng-template>
